import { Routes, RouterModule } from "@angular/router";
import { RiskScoreAuthoringComponent } from "./risk-score-authoring/risk-score-authoring.component";
import { RulesetSearchComponent } from "./ruleset/ruleset-search/ruleset-search.component";
import { RulesetCreateOrUpdateComponent } from "./ruleset/ruleset-create-or-update/ruleset-create-or-update.component";
import { RulesSearchComponent } from "./rules/rules-search/rules-search/rules-search.component";
import { RulesCreateOrUpdateComponent } from "./rules/rules-create/rules-create/rules-create-or-update.component";
import { AuthGuard } from "src/app/core/guard/utility.guard";
import { AccessFlowCreateOrUpdateComponent } from "./access-flow-authoring/access-flow-create-or-update/access-flow-create-or-update.component";
import { AccessFlowSearchComponent } from "./access-flow-authoring/access-flow-search/access-flow-search.component";
import { AdaAccessAuthoringToolsComponent } from "./auth-tool-home/authoring-tools/ada-access-authoring-tools.component";
import { AuthToolHomeComponent } from "./auth-tool-home/auth-tool-home.component";
import { AccessFlowRulesetCreateOrUpdateComponent } from "./access-flow-ruleset/access-flow-ruleset-create-or-update/access-flow-ruleset-create-or-update.component";
import { NodeUpdateComponent } from "./ruleset/node/node-update/node-update.component";
import { AacReportsComponent } from "./reports/aac-reports.component";
import { AacToolsComponent } from "./aac-tools/aac-tools.component";
import { AdaptiveAccessNodeCreateOrUpdateComponent } from "./adaptive-access-node/adaptive-access-node-create-or-update/adaptive-access-node-create-or-update.component";
import { AdaptiveAccessNodeSearchComponent } from "./adaptive-access-node/adaptive-access-node-search/adaptive-access-node-search.component";
import { AdaptiveAccessDashboardDataResolver } from "src/app/core/resolvers/adaptive-access/dashboard-data.resolver";

export const adaAccessRoutes: Routes = [
  {
    path: "ada-access/auth-tools",
    component: AdaAccessAuthoringToolsComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: "policy-authoring", component: RiskScoreAuthoringComponent },
      {
        path: "policy-authoring/ruleset/search",
        component: RulesetSearchComponent,
      },
      {
        path: "policy-authoring/ruleset/create",
        component: RulesetCreateOrUpdateComponent,
        data: { create: true },
      },
      {
        path: "policy-authoring/ruleset/update/:rulesetId",
        component: RulesetCreateOrUpdateComponent,
        data: { create: false },
      },

      {
        path: "policy-authoring/rules/create",
        component: RulesCreateOrUpdateComponent,
        data: { create: true },
      },
      {
        path: "policy-authoring/rules/update/:ruleId",
        component: RulesCreateOrUpdateComponent,
        data: { create: false },
      },
      {
        path: "adaptiveaccessnode/create",
        component: AdaptiveAccessNodeCreateOrUpdateComponent,
        data: { create: true },
      },
      {
        path: "adaptiveaccessnode/update/:adaptiveAccessNodeId",
        component: AdaptiveAccessNodeCreateOrUpdateComponent,
        data: { create: false },
      },

      {
        path: "adaptiveaccessnode/search",
        component: AdaptiveAccessNodeSearchComponent,
      },
      { path: "access-control-reports", component: AacReportsComponent },
      {
        path: "access-flow/create",
        component: AccessFlowCreateOrUpdateComponent,
        data: { create: true },
        
      },
      {
        path: "access-flow/update/:accessFlowId",
        component: AccessFlowCreateOrUpdateComponent,
        data: { create: false },
      },
      { path: "access-flow/search", component: AccessFlowSearchComponent },
      {
        path: "access-flow-ruleset/create/:accessFlowId",
        component: AccessFlowRulesetCreateOrUpdateComponent,
        data: { create: true },
      },
      {
        path: "access-flow-ruleset/update/:accessFlowId",
        component: AccessFlowRulesetCreateOrUpdateComponent,
        data: { create: false },
      },
      {
        path: "policy-authoring/node/update/:nodeId/:rulesetId",
        component: NodeUpdateComponent,
        data: { create: false },
      },
      {
        path: "policy-authoring/node/create/:existingRulesetId",
        component: NodeUpdateComponent,
        data: { create: true },
      },
      {
        path: "policy-authoring/rules/search",
        component: RulesSearchComponent,
      },
           {
        path: '',
        component: AuthToolHomeComponent,
        resolve: { dashboard: AdaptiveAccessDashboardDataResolver }
      },
    ],
  },
  // { path: "ada-access/auth-tools", component: AdaAccessAuthoringToolsComponent },
  { path: "ada-access/aac-tools", component: AacToolsComponent },
  { path: "ada-access/reports", component: AacReportsComponent },
];

export const adaAccessRouter = RouterModule.forChild(adaAccessRoutes);

// import { Routes, RouterModule } from "@angular/router";
// import { RiskScoreAuthoringComponent } from "./risk-score-authoring/risk-score-authoring.component";
// import { RulesetSearchComponent } from "./ruleset/ruleset-search/ruleset-search.component";
// import { RulesetCreateOrUpdateComponent } from "./ruleset/ruleset-create-or-update/ruleset-create-or-update.component";
// import { RulesSearchComponent } from "./rules/rules-search/rules-search/rules-search.component";
// import { RulesCreateOrUpdateComponent } from "./rules/rules-create/rules-create/rules-create-or-update.component";
// import { AuthGuard } from "src/app/core/guard/utility.guard";
// import { AssetSearchComponent } from "./asset/asset-search/asset-search.component";
// import { AssetCreateOrUpdateComponent } from "./asset/asset-create-or-update/asset-create-or-update.component";
// import { AccessFlowCreateOrUpdateComponent } from "./access-flow-authoring/access-flow-create-or-update/access-flow-create-or-update.component";
// import { AccessFlowSearchComponent } from "./access-flow-authoring/access-flow-search/access-flow-search.component";
// import { AdaAccessAuthoringToolsComponent } from "./auth-tool-home/authoring-tools/ada-access-authoring-tools.component";
// import { AuthToolHomeComponent } from "./auth-tool-home/auth-tool-home.component";
// import { AccessFlowRulesetCreateOrUpdateComponent } from "./access-flow-ruleset/access-flow-ruleset-create-or-update/access-flow-ruleset-create-or-update.component";
// import { NodeUpdateComponent } from "./ruleset/node/node-update/node-update.component";
// import { AacReportsComponent } from "./reports/aac-reports.component";
// import { AacToolsComponent } from "./aac-tools/aac-tools.component";
// import { AdaptiveAccessNodeCreateOrUpdateComponent } from "./adaptive-access-node/adaptive-access-node-create-or-update/adaptive-access-node-create-or-update.component";
// import { AdaptiveAccessNodeSearchComponent } from "./adaptive-access-node/adaptive-access-node-search/adaptive-access-node-search.component";
// import { AdaptiveAccessDashboardDataResolver } from "src/app/core/resolvers/adaptive-access/dashboard-data.resolver";
// import { GlobalDataResolver } from "src/app/core/resolvers/global-data.resolver";

// // SERVICES FOR RESOLVER
// import { AccessFlowService } from "./access-flow-authoring/access-flow.service";
// import { AdaptiveAccessNodeService } from "./adaptive-access-node/adaptive-access-node.service";
// import { AdaptiveAccessNodeRulesetService } from "./adaptive-access-node-ruleset/adaptive-access-node-ruleset-create-or-update/adaptive-access-node-ruleset.service";
// import { AccessFlowRulesetService } from "./access-flow-ruleset/access-flow-ruleset-create-or-update/access-flow-ruleset.service";
// import { AdaptiveAccessReportService } from "./reports/reports.service";
// import { RuleService } from "./rules/rules.service";
// import { RulesetService } from "./ruleset/ruleset.service";

// export const adaAccessRoutes: Routes = [
//  {
//     path: "ada-access/auth-tools",
//     component: AdaAccessAuthoringToolsComponent,
//     canActivate: [AuthGuard],
//     children: [
//       { path: "policy-authoring", component: RiskScoreAuthoringComponent },

//       /**
//        * RULESET CREATE/UPDATE
//        */
//       {
//         path: "policy-authoring/ruleset/create",
//         component: RulesetCreateOrUpdateComponent,
//         data: { create: true },
//       },
//       {
//         path: "policy-authoring/ruleset/update/:rulesetId",
//         component: RulesetCreateOrUpdateComponent,
//         resolve: { data: GlobalDataResolver },
//         data: {
//           create: false,
//           resolver: {
//             service: RulesetService,
//             method: "getRuleset",
//             args: [":rulesetId"],
//           },
//         },
//       },

//       { path: "policy-authoring/ruleset/search", component: RulesetSearchComponent },

//       /**
//        * RULE CREATE/UPDATE
//        */
//       {
//         path: "policy-authoring/rules/create",
//         component: RulesCreateOrUpdateComponent,
//         data: { create: true },
//       },
//       {
//         path: "policy-authoring/rules/update/:ruleId",
//         component: RulesCreateOrUpdateComponent,
//         resolve: { data: GlobalDataResolver },
//         data: {
//           create: false,
//           resolver: {
//             service: RuleService,
//             method: "getRule",
//             args: [":ruleId"],
//           },
//         },
//       },

//       /**
//        * ADAPTIVE ACCESS NODE CREATE/UPDATE
//        */
//       {
//         path: "adaptiveaccessnode/create",
//         component: AdaptiveAccessNodeCreateOrUpdateComponent,
//         data: { create: true },
//       },
//       {
//         path: "adaptiveaccessnode/update/:adaptiveAccessNodeId",
//         component: AdaptiveAccessNodeCreateOrUpdateComponent,
//         resolve: { data: GlobalDataResolver },
//         data: {
//           create: false,
//           resolver: {
//             service: AdaptiveAccessNodeService,
//             method: "getAdaptiveAccessNode",
//             args: [":adaptiveAccessNodeId"],
//           },
//         },
//       },

//       { path: "adaptiveaccessnode/search", component: AdaptiveAccessNodeSearchComponent },

//       /**
//        * ASSET CREATE/UPDATE
//        */
//       { path: "asset/search", component: AssetSearchComponent },
//       {
//         path: "asset/create",
//         component: AssetCreateOrUpdateComponent,
//         data: { create: true },
//       },
//       {
//         path: "asset/update/:assetId",
//         component: AssetCreateOrUpdateComponent,
//       },
      
//       /**
//        * ACCESS FLOW CREATE/UPDATE
//        */
//       {
//         path: "access-flow/create",
//         component: AccessFlowCreateOrUpdateComponent,
//         data: { create: true },
//       },
//       {
//         path: "access-flow/update/:accessFlowId",
//         component: AccessFlowCreateOrUpdateComponent,
//         resolve: { data: GlobalDataResolver },
//         data: {
//           create: false,
//           resolver: {
//             service: AccessFlowService,
//             method: "getAccessFlow",
//             args: [":accessFlowId"],
//           },
//         },
//       },

//       { path: "access-flow/search", component: AccessFlowSearchComponent },

//       /**
//        * ACCESS FLOW RULESET CREATE/UPDATE
//        */
//       {
//         path: "access-flow-ruleset/create/:accessFlowId",
//         component: AccessFlowRulesetCreateOrUpdateComponent,
//         data: { create: true },
//       },
//       {
//         path: "access-flow-ruleset/update/:accessFlowId",
//         component: AccessFlowRulesetCreateOrUpdateComponent,
//         resolve: { data: GlobalDataResolver },
//         data: {
//           create: false,
//           resolver: {
//             service: AccessFlowRulesetService,
//             method: "getAccessFlowRulesetByaccessFlowId",
//             args: [":accessFlowId"],
//           },
//         },
//       },

//       /**
//        * ADAPTIVE ACCESS NODE RULESET UPDATE
//        */
//       {
//         path: "adaptiveaccessnode/ruleset/update/:nodeRulesetId",
//         component: NodeUpdateComponent,
//         resolve: { data: GlobalDataResolver },
//         data: {
//           create: false,
//           resolver: {
//             service: AdaptiveAccessNodeRulesetService,
//             method: "getAdaptiveAccessNodeRuleset",
//             args: [":nodeRulesetId"],
//           },
//         },
//       },

//       /**
//        * NODE UPDATE / CREATE
//        */
//       {
//         path: "policy-authoring/node/update/:nodeId/:rulesetId",
//         component: NodeUpdateComponent,
//         data: { create: false },
//       },
//       {
//         path: "policy-authoring/node/create/:existingRulesetId",
//         component: NodeUpdateComponent,
//         data: { create: true },
//       },

//       /**
//        * RULE SEARCH
//        */
//       { path: "policy-authoring/rules/search", component: RulesSearchComponent },

//       /**
//        * REPORTS with Resolver
//        */
//       {
//         path: "access-control-reports",
//         component: AacReportsComponent,
//         resolve: { data: GlobalDataResolver },
//         data: {
//           resolver: {
//             service: AdaptiveAccessReportService,
//             method: "getAcReports",
//             args: ["default"], // replace with selectedFilter if needed
//           },
//         },
//       }

//       /**
//        * HOME / DASHBOARD
//        */
//       ,
//            {
//         path: '',
//         component: AuthToolHomeComponent,
//         resolve: { dashboard: AdaptiveAccessDashboardDataResolver }
//       },
//     ],
//   },
//   // { path: "ada-access/auth-tools", component: AdaAccessAuthoringToolsComponent },
//   { path: "ada-access/aac-tools", component: AacToolsComponent },
//   { path: "ada-access/reports", component: AacReportsComponent },
// ];

// export const adaAccessRouter = RouterModule.forChild(adaAccessRoutes);

